import axios from "axios";

export const fetchGetAllParentCompanies = async () => {
  return await axios.get("/api/parentcompany?pageSize=0");
};
